var map = {
	"./Feet/TerribleBoots/TerribleBoots_L.fbx": 4055,
	"./Feet/TerribleBoots/TerribleBoots_R.fbx": 8337,
	"./Hands/TerribleGloves/TerribleGloves_L.fbx": 1608,
	"./Hands/TerribleGloves/TerribleGloves_R.fbx": 1779,
	"./Head/BallCapBackward/BallCapBackward.fbx": 4262,
	"./Head/BallCapForward/BallCapForward.fbx": 982,
	"./Head/CheesyGlasses/CheesyGlasses.fbx": 5423,
	"./Head/ConeHat/ConeHat.fbx": 1094,
	"./Head/Headphones/Headphones.fbx": 8939,
	"./Head/Horns/Horns.fbx": 9608,
	"./Head/LibertySpikes/LibertySpikes.fbx": 246,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.fbx": 2252,
	"./Head/SantaHat/SantaHat.fbx": 1415,
	"./Head/Sideburns/Sideburns.fbx": 5411,
	"./Head/TopHat/TopHat.fbx": 8107,
	"./legs/TerriblePants/TerriblePants.fbx": 1750,
	"./torso/TerribleShirt/TerribleShirt.fbx": 1783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9978;